module.exports = __webpack_public_path__ + "img/login-vacina-sesi-logo.a560d56b.jpg";